<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <i class="pi pi-th-large title-card-icon"></i>
      <div>
        <p class="mb-0 text-3xl title">{{'model.applications' | transloco}}</p>
        <p>{{'menu.descriptions.applications' | transloco}}</p>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex flex-column sm:flex-row justify-content-between">
            <div class="flex flex-column md:flex-row">
              <button
                *ngIf="'ROLE_SUPER_ADMIN' | userHasRole"
                [label]="'common.new' | transloco"
                pButton
                pRipple
                class="md:mr-2 p-button-primary mb-2 md:mb-0"
                routerLink="new"
                icon="pi pi-plus"
              ></button>
            </div>
            <div *ngIf="!filtersFilled"  class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary"
                icon="pi pi-sliders-h"
              ></button>
            </div>
            <div *ngIf="filtersFilled"  class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary filtersFilled"
                icon="pi pi-filter"
              ></button>
            </div>
          </div>
        </div>
        <p-table
          [(rows)]="rows"
          [(first)]="first"
          [value]="applications"
          [totalRecords]="totalApplications"
          [sortOrder]="-1"
          [autoLayout]="true"
          [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
          [paginator]="true"
          [rowsPerPageOptions]="[10,25,50]"
          [lazy]="true"
          (onLazyLoad)="onPageChange($event)"
          styleClass="p-datatable-striped"
          sortField="code"
          responsiveLayout="stack"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="uuid">
                {{'attribute.uuid' | transloco}}<p-sortIcon field="uuid"></p-sortIcon>
              </th>
              <th pSortableColumn="code">
                {{'attribute.code' | transloco}}<p-sortIcon field="code"></p-sortIcon>
              </th>
              <th pSortableColumn="creationAt">
                {{'attribute.creationAt' | transloco}}<p-sortIcon field="creationAt"></p-sortIcon>
              </th>
              <th pSortableColumn="updatedAt">
                {{'attribute.updatedAt' | transloco}}<p-sortIcon field="updatedAt"></p-sortIcon>
              </th>
              <th pSortableColumn="description">
                {{'attribute.description' | transloco}}<p-sortIcon field="description"></p-sortIcon>
              </th>
              <th pSortableColumn="name">
                {{'attribute.name' | transloco}}<p-sortIcon field="name"></p-sortIcon>
              </th>
              <th pSortableColumn="url">
                {{'attribute.url' | transloco}}<p-sortIcon field="url"></p-sortIcon>
              </th>
              <th>{{'attribute.color' | transloco}}</th>
              <th class="w-10rem">
                {{'common.actions' | transloco}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-application>
            <tr *ngIf="!loadingApplications" class="fadein">
              <td>
                <span class="p-column-title bold">{{'attribute.uuid' | transloco}}</span>
                <p class="text-right md:text-left">{{application.uuid}}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.code' | transloco}}</span>
                <p class="text-right md:text-left">{{application.code}}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.creationAt' | transloco}}</span>
                <p class="text-right md:text-left">{{application.creationAt | customDate}}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.updatedAt' | transloco}}</span>
                <p class="text-right md:text-left">{{application.updatedAt | customDate}}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
                <p class="text-right md:text-left">{{application.description}}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
                <p class="text-right md:text-left">{{application.name}}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.url' | transloco}}</span>
                <a [href]="'//'+application.url" target="_blank">{{application.url}}</a>
              </td>
              <td>
                <div class="flex flex-column">
                  <label [style.background-color]="application.color" readonly class="theme-picker">
                    <input [(ngModel)]="application.color" disabled type="color">
                  </label>
                  <p class="text-right md:text-left">{{application.color}}</p>
                </div>
              </td>
              <td>
                <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
                <div class="flex justify-content-end">
                  <button
                    [routerLink]="[application.uuid, 'edit']"
                    pButton
                    pRipple
                    class="p-button-rounded btn-primary-light mr-2"
                    icon="pi pi-pencil"
                  ></button>
                  <button
                    (click)="confirmAndDelete(application)"
                    pButton
                    pRipple
                    class="p-button-rounded btn-danger-light"
                    icon="pi pi-trash"
                  ></button>
                </div>
              </td>
            </tr>
            <tr *ngIf="loadingApplications" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
              <td class="row-height selection-column-width">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between" *ngIf="totalApplications == 0">
              {{'pagination.empty' | transloco}}
            </div>
            <div class="flex align-items-center justify-content-between" *ngIf="totalApplications > 0">
              {{'pagination.showing' | transloco}} {{first+1}}
              {{'pagination.to' | transloco}} {{(first+rows) >= totalApplications ? totalApplications : (first+rows)}}
              {{'pagination.of' | transloco}} {{totalApplications}}
              {{(totalApplications > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
  <div>
    <h2 style="margin-left: 10px;">{{'common.filters' | transloco}}</h2>
    <div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="code">{{'attribute.code' | transloco}}</label>
        </div>
        <div class="col-12">
          <input
            [(ngModel)]="currentFilters.code"
            [focus]="filtersVisible"
            (keyup.enter)="filtersVisible = false; applyFilters()"
            pInputText
            appAutoFocus
            class="w-full"
            id="code"
            type="text"
          >
        </div>
      </div>
      <div class="col-12">
        <p-button
          [label]="'common.filter' | transloco"
          [disabled]="!(currentFilters.code)"
          (onClick)="filtersVisible = false; applyFilters()"
          styleClass="p-button-primary mx-2 mt-2"
          type="button"
        ></p-button>
        <p-button
          [label]="'common.clear' | transloco"
          (click)="resetFilters(); filtersVisible = false;"
          styleClass="p-button-danger"
          type="button"
        ></p-button>
      </div>
    </div>
  </div>
</p-sidebar>
